import {
  LOGIN_SUCCESS,
  UPDATE_USER,
  LOGIN_FAIL,
  LOGOUT,
  LOGIN_LOADING,
  TENANT_SELECTED,
} from "./types";
const storedUser = localStorage.getItem("user");
const parsedUser = storedUser ? JSON.parse(storedUser) : null;
const initialState = parsedUser
  ? { isLoggedIn: true, isLoading: false, user: parsedUser, tenant: null }
  : { isLoggedIn: false, isLoading: false, user: null, tenant: null };
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_LOADING:
      return {
        ...state,
        isLoading: true,
        isLoggedIn: false,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: payload,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        user: payload.user,
        tenant:
          payload.user.tenants.length > 0 ? payload.user.tenants[0]._id : null,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        user: null,
        tenant: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        user: null,
        tenant: null,
      };
    case TENANT_SELECTED:
      console.log("current Tenant", state.tenant);
      console.log("Setting Tenant", payload);
      return {
        ...state,
        tenant: payload,
      };
    default:
      return state;
  }
}
